module.exports = __webpack_public_path__ + "img/avaya.d20d4895.png";